import React, { useState } from 'react';
import { Button } from '@react-spectrum/button';
import { ButtonGroup } from '@react-spectrum/buttongroup';
import { Dialog } from '@react-spectrum/dialog';
import { Divider } from '@react-spectrum/divider';
import { Flex } from '@react-spectrum/layout';
import { Heading, Text } from '@react-spectrum/text';
import { TextField } from '@react-spectrum/textfield';
import { Content } from '@react-spectrum/view';
import { ImageActions } from 'app/stores/image/actions';
import { useAppDispatch } from 'app/stores/store';
import { call } from 'app/utils/function';
export function DownloadDialog(props) {
    var _a;
    const { onDownload, close } = props;
    const dispatch = useAppDispatch();
    const [value, setValue] = useState((_a = props.url) !== null && _a !== void 0 ? _a : '');
    const hasValidText = (value !== null && value !== void 0 ? value : '').length > 0 && /^https?:\/\/.+/i.test(value);
    const download = React.useCallback(() => {
        dispatch(ImageActions.downloadImage(value)).then(() => call(onDownload, value));
    }, [value, onDownload, dispatch]);
    return (React.createElement(Dialog, null,
        React.createElement(Heading, null, "Download an image"),
        React.createElement(Divider, { size: "S" }),
        React.createElement(Content, null,
            React.createElement(Flex, { direction: "column" },
                React.createElement(Text, null, "Enter image url to download it."),
                React.createElement(TextField, { width: "100%", flex: "1", isRequired: true, autoFocus: true, label: "URL to supported image file (only jpg, png are supported)", value: value, onChange: setValue }))),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "secondary", onPress: close }, "Cancel"),
            React.createElement(Button, { variant: "cta", onPress: download, isDisabled: !hasValidText }, "Download"))));
}
